/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import Questions from 'components/Questions'
import ButtonLanding from './ButtonLanding'

const Section = styled.section`
  @media (min-width: 992px) {
    padding-top: 94px;
    padding-bottom: 134px;
  }

  @media (max-width: 991.98px) {
    padding-block: 2rem;
  }
`

const Card = styled.div`
  max-width: 821px;
  margin-inline: auto;
  background-color: #fff;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.5);

  & h2 {
    text-align: center;
    color: ${(props) => props.theme.color.text.main};
    font-weight: 600;
  }

  /* The accordion rows and their dividers share the design's narrow measure. */
  & hr {
    margin-block: 0;
    border-top: 1px solid ${(props) => props.theme.color.text.main};
  }

  & .font-size-xm {
    font-size: 18px;
  }

  /* Figma spaces each question generously between its dividers. */
  & .font-size-xm.py-3 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }

  @media (min-width: 992px) {
    padding: 50px 120px 60px;

    & h2 {
      font-size: 50px;
      line-height: 50px;
      margin-bottom: 56px;
    }
  }

  @media (max-width: 991.98px) {
    padding: 2rem 1.5rem;

    & .font-size-xm.py-3 {
      padding-top: 1.5rem !important;
      padding-bottom: 1.5rem !important;
    }

    & h2 {
      font-size: 32px;
      margin-bottom: 1.5rem;
    }
  }
`

function FaqLanding({ title, questions, link }) {
  return (
    <Section>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <Card>
              {title && <h2>{title}</h2>}

              <Questions questIds={questions} />

              {link && (
                <div className="d-flex justify-content-center mt-5">
                  <ButtonLanding
                    to={link.url}
                    target={link.target}
                    variant="red"
                    notch={16}
                  >
                    {link.title}
                  </ButtonLanding>
                </div>
              )}
            </Card>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default FaqLanding
